import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { LoaderView } from "../../loader/loader.comp";
import NotFound from "../../../views/not-found/not-found";

const SuperAdminProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { user, isSuperAdmin } = FirebaseAuthContainer.useContainer();

    return user ? isSuperAdmin ? children : <NotFound /> : <LoaderView show={true} />;
};

export default SuperAdminProtectedRoute;
